import { Injectable } from '@angular/core';
import { HttpClient,HttpErrorResponse, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable, throwError} from 'rxjs';
import { map,catchError, } from 'rxjs/operators';
import { EnvService } from '../services/env.service';

const httpOptions= {headers: new HttpHeaders({'Content-Type':'application/json'}) };

@Injectable({
  providedIn: 'root'
})
export class SolarPowerMgtService {

  dataRow : any;

  constructor(private http: HttpClient,private env: EnvService) {

   }

   getMaxId() :Observable <any[]>{
     return this.http.get<any[]>(`${this.env.apiUrl}/solar-power/getMaxId`,httpOptions)
     .pipe(catchError(this.handleError));
        
     }

   getAll():Observable <any[]> {
    return this.http.get<any[]>(`${this.env.apiUrl}/solar-power`,httpOptions)
    .pipe(catchError(this.handleError));
       
    }

    getPreviuosData():Observable <any[]> {
      return this.http.get<any[]>(`${this.env.apiUrl}/solar-power/getPreviuosData`,httpOptions)
      .pipe(catchError(this.handleError));
         
      }


    create(data):Observable <any>{
      return this.http.post<any>(`${this.env.apiUrl}/solar-power`,  data ,httpOptions)
        .pipe(catchError(this.handleError));
       
    }

    update(data):Observable <void>{
      return this.http.put<void>(`${this.env.apiUrl}/solar-power`, data ,httpOptions)
        .pipe(catchError(this.handleError));
       
    }

    delete(id: string) : Observable <void>{
      return this.http.delete<void>(`${this.env.apiUrl}/solar-power/${id}`,httpOptions)
        .pipe(catchError(this.handleError));
       
    }



    private handleError(errorResponse: HttpErrorResponse) {
      return throwError(errorResponse || "Server Error");

      }
      
     }
